import { DateRangePicker } from '@progress/kendo-react-dateinputs'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import bodybuilder from 'bodybuilder'
import { DropdownComponent, DropdownOption } from 'components/dropdown/component'
import { HeaderComponent } from 'components/header/component'
import { Dataset } from 'generic/dataset'
import { Topics } from 'components/icons/topics'
import {
  AggregationType,
  CONCEPT_TAG_TYPES,
  DateRangesAsDropdownOptions,
  FilterType,
  getMessageSendDateFilterField,
  IndexName,
  SuspectFilterDropdownOptions,
  TAG_TYPE_FIELD,
  toFilter
} from 'elasticsearch/constants'
import { ResponseAggregate, ResponsePayload } from 'elasticsearch/types'
import { ElasticsearchComponent, ElasticsearchProps } from 'generic/elasticSearchComponent'
import * as GenericRedux from 'generic/genericRedux'
import { startCase } from 'lodash'
import React, { ComponentType } from 'react'
import { Button } from 'reactstrap'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle } from '@progress/kendo-react-charts'
import { Loading } from 'components/loading'
import { AjaxWrapper, HttpMethod } from '../../generic/ajaxWrapper'
import { EditableDropdownCell, EditCellProps } from '../../generic/editCell'
import * as Constants from './constants'
import { RasaAnalyticsComponent } from './rasa-analytics-component'
import './styles.css'
import * as GenericUtils from '../../generic/utility'
import { ConnectedComponentClass } from 'react-redux'
import { Fields } from '../../shared/modals'
import * as Flash from '../flash'
import * as Sentry from '@sentry/browser'
import * as Modals from '../../shared/modals'
import * as Utils from "./utils";
import { PDFReportHeader } from './PDFReportHeader'
import { BaseClientEntity } from 'generic/baseClientEntity'

export class TopicsComponentClass extends RasaAnalyticsComponent<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      selectedDateRange: this.findDropdownOptionByValue(DateRangesAsDropdownOptions, Constants.AnalyticsFilterKeys.SELECTED_DATE_RANGE, DateRangesAsDropdownOptions[2].value),
      selectedSource: this.findDropdownOptionByValue(Constants.SourceFilters,Constants.AnalyticsFilterKeys.SELECTED_SOURCE),
      selectedSuspectClick:  this.findDropdownOptionByValue(SuspectFilterDropdownOptions, Constants.AnalyticsFilterKeys.SELECTED_SUSPECT_CLICK),
    }
  }

  public componentDidMount() {
    super.componentDidMount()
    this.minCustomDateRange()
  }

  public render() {
    return (
      <div className="analytics-component">
        <HeaderComponent
          title={'ANALYTICS'}
          subTitle={'Topics'}
          description={[
            'The content topics your contacts are clicking on the most.',
          ]}
        />
        <div className="dropdown-header">
          <div className="dropdown-inline">
            <DropdownComponent
              data={DateRangesAsDropdownOptions}
              selected={this.state.selectedDateRange.key}
              onChange={this.dateChanged}
            />
          </div>
          <div className="dropdown-inline">
            <DropdownComponent
              data={Constants.SourceFilters}
              selected={this.state.selectedSource.key}
              onChange={this.sourceChanged}
            />
          </div>
          <div className="dropdown-inline">
            <DropdownComponent
              data={SuspectFilterDropdownOptions}
              selected={this.state.selectedSuspectClick.key}
              onChange={this.suspectedClickChanged}
            />
          </div>
        </div>
        <div className="date-range-picker">
        {this.state.selectedDateRange.key === '7' ?
        <DateRangePicker onChange={this.createCustomDate}
          min={this.state.minCustomDateRange} max ={new Date()} /> : null}
        </div>
        <AnalyticsTopicsTable
          openModal={() => this.props.openModal(ExportTopicReportStartedModal.key, {})}
          dateRange={this.state.selectedDateRange.value}
          dateRangeLabel={this.state.selectedDateRange.description}
          source={this.state.selectedSource.value}
          sourceLabel={this.state.selectedSource.description}
          suspectClick={this.state.selectedSuspectClick.value}
          timezone={this.state.timezone}
          useTimezoneForAnalytics={this.state.useTimezoneForAnalytics}
        />
        <div className="modal-wrapper">
          <ExportTopicReportStartedModal data={this.props.modals} closeModal={this.props.closeModal} title="Export Started" />
        </div>
      </div>
    )
  }

  private findDropdownOptionByValue = (filters: DropdownOption[], queryKey: string, defaultValue?: string) => {
    const valueToFind = this.getQuery(queryKey, defaultValue)
    const found = filters.find((x) => x.value === valueToFind)
    return found || filters[0]
  }
}

interface Topic {
  name: string,
  key: string,
  totalClicks?: number,
  uniqueClicks?: number,
  weightedScore?: number,
}

type Topics = Topic[]

interface TopicsProps extends ElasticsearchProps<Topics> {
  dateRange: any,
  source: any,
  openModal: any,
  suspectClick: string,
  timezone?: string,
  useTimezoneForAnalytics?: any,
  dateRangeLabel?: string,
  sourceLabel?: string
}

interface TopicsState {
  loaded: boolean,
  excludedTopics: string[],
  isLoadingData: boolean,
}

const TAG_NAME_AGG: string = 'tag'
const WEIGHTED_AGG: string = 'weighted'
const SOURCE_CUSTOM: string = 'Custom'

class TopicsTableComponent extends ElasticsearchComponent<Topics, TopicsProps, TopicsState> {
  private xlsxExport: any = null
  private pdfExportRef: React.RefObject<HTMLDivElement> = React.createRef()
  constructor(p: TopicsProps) {
    super(p, IndexName.TAGS)
    this.state = {
      loaded: false,
      excludedTopics: [],
      isLoadingData: false,
    }
    this.reportName = Constants.REPORT_NAMES.TOPICS
  }

  public parseResponse(payload: ResponsePayload): Promise<Topics> {
    this.setState({
      loaded: true,
      isLoadingData: false,
    })
    const aggregations = payload.aggregations[TAG_NAME_AGG]
    return Promise.resolve(aggregations.buckets.map((aggregation: ResponseAggregate) => {
      const weightedAgg = (aggregation as any)[WEIGHTED_AGG]
      return {
        name: startCase(aggregation.key.toLowerCase()),
        key: aggregation.key, // key is the original tag name. Needed in export
        totalClicks: aggregation.doc_count,
        uniqueClicks: aggregation.unique.value,
        weightedScore: Math.round((weightedAgg && weightedAgg.value) || 0),
      }
    }))
  }

  public componentDidMount() {
    // Override the parent componentDidMount to load excluded topics after communityId is set
    this.context.user.init().then(({person, activeCommunity}) => {
      this.communityId = activeCommunity.communityId
      this.loadExcludedTopics()
    })
  }

  public componentDidUpdate(oldProps: TopicsProps) {
    if (
      this.props.dateRange !== oldProps.dateRange ||
      this.props.source !== oldProps.source ||
      this.props.suspectClick !== oldProps.suspectClick ) {
      this.setState({ isLoadingData: true })
      this.search()
    }
  }

  public searchPayload(): any {
    const search = this.generateSearchQuery()
    return this.addAggregation(search, {
      type: AggregationType.terms,
      field: 'text.keyword',
      name: TAG_NAME_AGG,
      unique_on: 'community_person_id',
      extra: {
        size: Constants.ANALYTICS_TOPICS_LIMIT,
        order: { [WEIGHTED_AGG]: 'desc' },
      },
      childs: [
        { type: AggregationType.sum, field: 'weight', name: WEIGHTED_AGG },
      ],
    }).build()
  }

  public exportToPDF = async () => {
    if (!this.pdfExportRef.current) return

    try {
      const element = this.pdfExportRef.current

      // Temporarily add PDF export mode class to show PDF elements
      element.classList.add('pdf-export-mode')

      // Wait a brief moment for styles to apply
      await new Promise(resolve => setTimeout(resolve, 100))

      const pdf = new jsPDF('l', 'mm', 'a4') // landscape orientation
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      // Capture header and chart separately (Page 1)
      const headerChart = element.querySelector('.pdf-header-chart-section')
      if (headerChart) {
        const headerCanvas = await html2canvas(headerChart as HTMLElement, {
          height: headerChart.scrollHeight,
          width: headerChart.scrollWidth,
          useCORS: true,
          scale: 2
        })

        const headerImgData = headerCanvas.toDataURL('image/png')
        const headerRatio = Math.min(pdfWidth / headerCanvas.width, pdfHeight / headerCanvas.height)
        const headerImgX = (pdfWidth - headerCanvas.width * headerRatio) / 2

        pdf.addImage(headerImgData, 'PNG', headerImgX, 10, headerCanvas.width * headerRatio, headerCanvas.height * headerRatio)
      }

      // Capture table separately (Page 2+)
      const tableSection = element.querySelector('.pdf-table-section')
      if (tableSection && this.props.results && this.props.results.length > 0) {
        const itemsPerPage = 20
        const totalPages = Math.ceil(this.props.results.length / itemsPerPage)

        for (let page = 0; page < totalPages; page++) {
          pdf.addPage()

          // Add page header
          pdf.setFontSize(16)
          pdf.text(`Topics Report - Page ${page + 2} of ${totalPages + 1}`, 20, 20)
          pdf.setFontSize(12)
          pdf.text(`Showing entries ${page * itemsPerPage + 1} - ${Math.min((page + 1) * itemsPerPage, this.props.results.length)} of ${this.props.results.length}`, 20, 30)

          // Create table data for this page
          const pageData = this.props.results.slice(page * itemsPerPage, (page + 1) * itemsPerPage)

          // Simple table rendering
          let yPosition = 50
          const rowHeight = 8
          const colPositions = [20, 120, 200]

          // Table headers
          pdf.setFontSize(10)
          pdf.setFont(undefined, 'bold')
          pdf.text('Topic', colPositions[0], yPosition)
          pdf.text('Total Clicks', colPositions[1], yPosition)
          pdf.text('Unique Clicks', colPositions[2], yPosition)
          yPosition += rowHeight + 2

          // Table rows
          pdf.setFont(undefined, 'normal')
          pageData.forEach((item: any) => {
            if (yPosition > pdfHeight - 20) return // Stop if near bottom of page

            pdf.text(item.name ? item.name.substring(0, 40) : 'N/A', colPositions[0], yPosition)
            pdf.text((item.totalClicks || 0).toString(), colPositions[1], yPosition)
            pdf.text((item.uniqueClicks || 0).toString(), colPositions[2], yPosition)
            yPosition += rowHeight
          })
        }
      }

      // Remove PDF export mode class
      element.classList.remove('pdf-export-mode')

      pdf.save('topics-report.pdf')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error generating PDF:', error)
      // Make sure to remove the class even if there's an error
      if (this.pdfExportRef.current) {
        this.pdfExportRef.current.classList.remove('pdf-export-mode')
      }
    }
  }

  public render = () => <div>
    <div className="topics-chart">
      {this.state.isLoadingData ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Loading size="32" />
        </div>
      ) : (this.props.results && this.props.results.length > 0 ?
      <div>
        <div className="articles-export-buttons">
          <Button
            disabled={this.props.results.length < 1 || this.state.isLoadingData}
            onClick={() => this.xlsxExport.save()}>
            Export xlsx
          </Button>
          <Button
            color="secondary"
            disabled={this.props.results.length < 1 || this.state.isLoadingData}
            onClick={this.exportToPDF}>
            Export PDF
          </Button>
        </div>
        <div ref={this.pdfExportRef}>
          <div className="pdf-header-chart-section">
            <PDFReportHeader
              title="Topics Report"
              dateRange={this.props.dateRange}
              dateRangeLabel={this.props.dateRangeLabel}
              fields={[
                {
                  label: 'Source Filter',
                  value: this.props.sourceLabel || this.props.source
                },
                {
                  label: 'Suspect Click Filter',
                  value: Utils.getDisplayedClickType(this.props.suspectClick).title
                }
              ]}
              analysis="Top performing content topics by click engagement"
            />

            {this.props.results && this.props.results.length > 0 && (
              <div className="pdf-chart-section">
                <h3>Top 20 Topics - Total vs Unique Clicks</h3>
                <Chart style={{ height: '400px' }}>
                  <ChartTitle text="Topic Performance Comparison" />
                  <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                      categories={this.props.results.slice(0, 20).map((item: any) =>
                        item.name ? item.name.substring(0, 20) + '...' : 'Untitled'
                      )}
                      labels={{ rotation: -45 }}
                    />
                  </ChartCategoryAxis>
                  <ChartSeries>
                    <ChartSeriesItem
                      type="column"
                      data={this.props.results.slice(0, 20).map((item: any) => item.totalClicks || 0)}
                      name="Total Clicks"
                      color="#8fd1bb"
                    />
                    <ChartSeriesItem
                      type="column"
                      data={this.props.results.slice(0, 20).map((item: any) => item.uniqueClicks || 0)}
                      name="Unique Clicks"
                      color="#fcc3a7"
                    />
                  </ChartSeries>
                </Chart>
              </div>
            )}
          </div>

          <div className="pdf-table-section">
            <h3>Detailed Topic Performance</h3>
            <Grid data={this.props.results} className="analytics-counts-grid" scrollable="none">
              <GridColumn field="name" title="Topic" />
              <GridColumn field="weightedScore" title="Weighted Score"/>
              <GridColumn field="totalClicks" title="Total Clicks"/>
              <GridColumn field="uniqueClicks" title="Unique Clicks"/>
            </Grid>
          </div>
        </div>
        <ExcelExport data={this.props.results}
          fileName="RasaAdminReports.xlsx"
          ref={(exporter) => {this.xlsxExport = exporter}}>
          <Grid data={this.props.results} className="analytics-counts-grid" scrollable="none">
            <GridColumn field="name" title="Topic" />
            <GridColumn field="weightedScore" title="Weighted Score"/>
            <GridColumn field="totalClicks" title="Total Clicks"/>
            <GridColumn field="uniqueClicks" title="Unique Clicks"/>
            <GridColumn cell={this.SourceEditCell} width="50%" />
          </Grid>
        </ExcelExport>
      </div> :
      <div>
        <p className="no-data-tag">
          {Constants.NO_DATA_COPY}
        </p>
    </div>)
      }
    </div>
  </div>

  protected SourceEditCell = (props: EditCellProps) => {
    return <EditableDropdownCell
        {...props}
        showExport={true}
        onClickExport={(result) => this.getEmailsByTopic(result)}
        showCustomLink={true}
        customLabel="Exclude"
        onCustomClick={(event) => this.excludeTopic(props.dataItem)}
      />
  }

  private loadExcludedTopics = () => {
    new Dataset()
      .loadCommunityDataset('communityExcludedTopics', this.communityId, [])
      .then((response) => {
        const excludedTopics = (response[0] || []).map((topic: any) => topic.topic)
        this.setState({ excludedTopics }, () => {
          // Trigger search after loading excluded topics
          this.search()
        })
      })
      .catch((error) => {
        // Continue without excluded topics filter
        this.setState({ excludedTopics: [] })
      })
  }

  private generateSearchQuery = (): bodybuilder.Bodybuilder => {
    let search = bodybuilder().size(0).filter(
      FilterType.range, getMessageSendDateFilterField(this.props.dateRange, this.props.useTimezoneForAnalytics), toFilter(this.props.dateRange, this.props.timezone, this.props.useTimezoneForAnalytics))
    // Insights only: drop taxonomy `categories` rows; include both case variants until index normalizes.
    if (this.props.source === Constants.SourceFilterOption.RASA_TAGS) {
      search = search.filter(FilterType.terms, TAG_TYPE_FIELD, CONCEPT_TAG_TYPES)
      search = search.notFilter(FilterType.term, 'source.keyword', SOURCE_CUSTOM)
    } else if (this.props.source === Constants.SourceFilterOption.CUSTOM_TAGS) {
      search = search.filter(FilterType.term, 'source.keyword', SOURCE_CUSTOM)
    }
    if (this.props.suspectClick && Utils.isRealClickSelected(this.props.suspectClick)) {
      search.addFilter(FilterType.term, 'suspect_click', 0)
    }

    // Filter out excluded topics
    if (this.state.excludedTopics && this.state.excludedTopics.length > 0) {
      this.state.excludedTopics.forEach(excludedTopic => {
        search = search.notFilter(FilterType.term, 'text.keyword', excludedTopic)
      })
    }

    return search
  }

  private excludeTopic = (topic: Topic) => {
    // Add topic to exclusion list
    this.context.entityMetadata
      .getEntityObject('communityTopics', this.communityId, null)
      .then((topicEntityObject: BaseClientEntity) => {
        topicEntityObject.setRecordId(this.communityId, null)
        topicEntityObject.data.topic = topic.key
        topicEntityObject.data.communityIdentifier = this.communityId
        return topicEntityObject.save()
      })
      .then(() => {
        // Update local excluded topics list and refresh search
        this.setState({
          excludedTopics: [...this.state.excludedTopics, topic.key]
        }, () => {
          // Refresh the search to apply the new exclusion
          this.search()
        })
      })
      .catch((error) => {
        // Show error message to user
        this.context.store.dispatch(Flash.showFlashError('Failed to exclude topic. Please try again.'))
      })
  }

  private getEmailsByTopic = (topic: Topic) => {
    const url: URL = new URL(`/${this.communityId}/topics-unique-emails/export`, AjaxWrapper.getServerUrl())
    url.search = new URLSearchParams([['topic', topic.key]]).toString()
    const search = this.generateSearchQuery().addFilter(FilterType.term, 'text.keyword', topic.key)

    const payload = {
      topicName: topic.key,
      search: search
        .build()
    }
    AjaxWrapper.ajax(url.href, HttpMethod.POST, payload)
      .then((response) => {
        const { status, data } = response

        if (status === 'done' && data) {
          return GenericUtils.downloadTextFile(data, 'csv', topic.name)
        } else if (status === 'pending') {
          return this.props.openModal()
        }

        throw new Error(`Unknown response from ${url.href}`)
      })
      .catch((err) => {
        this.context.store
          .dispatch(Flash.showFlashError('\'Oops! There was a problem exporting your topic report. Please try again.'))
        Sentry.captureException(err)
      })
  }
}

class ExportTopicReportStartedModal extends Modals.ModalComponent {
  public static key: string = 'topicReportExportStart'
  constructor(props: Modals.ModalComponentProps) {
    super(props, ExportTopicReportStartedModal.key)
  }
  protected renderChildren(data: any) {
    return 'We are exporting your topic report now. Check your inbox for a link to download the list.'
  }
}

export const AnalyticsTopicsTable: ConnectedComponentClass<ComponentType<TopicsTableComponent>, Fields> = GenericRedux.registerNewComponent(
  TopicsTableComponent, 'home_topics', {})

export const TopicsComponent = GenericRedux.registerNewComponentWithModals(
  TopicsComponentClass,
  'analytics_topic_modal',
  [ExportTopicReportStartedModal.key],
  {}
)
